export const API_GET_ANALYSIS_IMPORT = "API_GET_ANALYSIS_IMPORT";
export const API_GET_ANALYSIS_IMPORT_FAIL = "API_GET_ANALYSIS_IMPORT_FAIL";
export const API_GET_ANALYSIS_IMPORT_SUCCESS = "API_GET_ANALYSIS_IMPORT_SUCCESS";
export const API_GET_ANALYSIS_IMPORT_FILE = "API_GET_ANALYSIS_IMPORT_FILE";
export const API_GET_ANALYSIS_IMPORT_FILE_FAIL = "API_GET_ANALYSIS_IMPORT_FILE_FAIL";
export const API_GET_ANALYSIS_IMPORT_FILE_SUCCESS = "API_GET_ANALYSIS_IMPORT_FILE_SUCCESS";
export const API_GET_CATALOG_LOGS = "API_GET_CATALOG_LOGS";
